export default __webpack_public_path__ + "static/media/brave_zone_l1.beb3e5bb.png";